export const GET_SchedulePage_REQUEST = "GET_SchedulePage_REQUEST";
export const GET_SchedulePage_SUCCESS = "GET_SchedulePage_SUCCESS";
export const GET_SchedulePage_FAILURE = "GET_SchedulePage_FAILURE";